import { headerStyles } from "@insite/content-library/Widgets/Budget/BudgetManagementHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

headerStyles.titleGridItem = {
    width: [10, 9, 7, 5, 6],
};
headerStyles.buttonsGridItem = {
    width: [2, 3, 5, 7, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};

headerStyles.gridContainer = {
    css: css`
        margin-top: 10px;
    `,
};
headerStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    css`
                        button {
                            background: none !important;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
headerStyles.costCodesButton = {
    variant: "tertiary",
    css: css`
        white-space: nowrap;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: none;
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
headerStyles.assignBudgetsButton = {
    variant: "tertiary",
    css: css`
        white-space: nowrap;
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: none;
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};
headerStyles.configureBudgetsButton = {
    css: css`
        white-space: nowrap;
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: none;
        span[class^="TypographyStyle"] {
            color: ${getColor("secondary")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            background: ${getColor("text.accent")};
            /* border: 2px solid  background: ${getColor("text.accent")}; */
            span[class^="TypographyStyle"] {
                color: ${getColor("secondary")};
            }
        }
    `,
};

headerStyles.titleText = {
    variant: "h2",
    as: "h2",
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.base};
        font-weight: ${TYPOGRAPHY.weight.bold};
        font-size: 24px;
        font-style: normal;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                null,
                null,
            ])}
    `,
};
